import { useEffect, useState } from 'react';
import { X, Check, AlertTriangle } from 'lucide-react';

export type BannerType = 'error' | 'success' | 'warning';

interface NotificationBannerProps {
  message: string;
  type?: BannerType;
  duration?: number; // ms, 0 = manual dismiss
  onDismiss?: () => void;
}

export function NotificationBanner({
  message,
  type = 'success',
  duration = 4000,
  onDismiss,
}: NotificationBannerProps) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        setVisible(false);
        onDismiss?.();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onDismiss]);

  if (!visible) return null;

  const icon = type === 'error' ? <X size={16} /> : type === 'success' ? <Check size={16} /> : <AlertTriangle size={16} />;

  return (
    <div
      className={`notification-banner ${type}`}
      role="alert"
      aria-live="assertive"
    >
      <span aria-hidden="true">{icon}</span>
      <span style={{ flex: 1 }}>{message}</span>
      <button
        type="button"
        onClick={() => { setVisible(false); onDismiss?.(); }}
        aria-label="Dismiss notification"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: 'var(--font-size-md)',
          padding: '0 var(--space-1)',
          color: 'inherit',
        }}
      >
        <X size={16} />
      </button>
    </div>
  );
}
